import { Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { DailyAdButtonLayout } from '../../../layouts/popups/dailyReward/DailyAdButtonLayout';
import { DailyRewardClaimedLayout } from '../../../layouts/popups/dailyReward/DailyRewardClaimedLayout';
import { DailyLockedButtonLayout } from '../../../layouts/popups/dailyReward/DailyLockedButtonLayout';

export enum DailyRewardOfferButtonState {
  Claimed = 'Claimed',
  Active = 'Active',
  Locked = 'Locked',
}

export class DailyRewardOfferButtonView extends Container {
  public readonly onClicked = new Signal();

  private currentState: DailyRewardOfferButtonState | null = null;

  public setState(state: DailyRewardOfferButtonState): this {
    if (this.currentState === state) return this;

    this.children.slice().forEach((child) => {
      child.destroy();
    });
    this.currentState = state;

    const root: Container = {
      [DailyRewardOfferButtonState.Active]: () => new DailyAdButtonLayout().root,
      [DailyRewardOfferButtonState.Locked]: () => new DailyLockedButtonLayout().root,
      [DailyRewardOfferButtonState.Claimed]: () => new DailyRewardClaimedLayout().root,
    }[state]();

    root.props({
      parent: this,
    });

    root.on('pointertap', () => {
      this.onClicked.emit();
    });

    return this;
  }
}
